import * as React from 'react'

function SvgBa(props) {
	return (
		<svg viewBox="0 0 16 8" width="1em" height="1em" {...props}>
			<path fill="#002395" d="M0 0h16v8H0z" />
			<path d="M4.24 0h8v8z" fill="#fecb00" />
			<g id="ba_svg__b">
				<path
					d="M2.353.525L2.8-.85 3.247.525l-1.17-.85h1.446z"
					fill="#fff"
					id="ba_svg__a"
				/>
				<use xlinkHref="#ba_svg__a" x={1} y={1} />
				<use xlinkHref="#ba_svg__a" x={2} y={2} />
			</g>
			<use xlinkHref="#ba_svg__b" x={3} y={3} />
			<use xlinkHref="#ba_svg__b" x={6} y={6} />
		</svg>
	)
}

export default SvgBa
